import React, { useState, useEffect } from 'react';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MUIDataTable from "mui-datatables";
import { useDispatch, useSelector } from 'react-redux';
import ShortcutIcon from '@mui/icons-material/Shortcut';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CancelIcon from '@mui/icons-material/Cancel';
import moment from 'moment';
import { fetchAccountOverview } from '../../store/actions/account-actions';
import { useHistory } from 'react-router-dom';
import { fetchShareList,setCurrentSharingCampaignId } from '../../store/actions/campaign-summary-actions';


const CampaignDashboardTableStyle = {
    actions:{
      color: '#4651B5',
      marginRight: "3rem",
      cursor: 'pointer'
    },
    actionDelete:{
      color: '#EF4444',
      cursor: 'pointer'
    },

}

const CampaignDashboardTable = props => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [campaignsState, preWorkCampaignsState] = useState();

  const currenAccountId = useSelector(
    state =>  state.account.accountOverviewData.account && state.account.accountOverviewData.account.id
  );

  const accountRoles  = useSelector(
    state =>  state.account.accountOverviewData.account && state.account.accountOverviewData.account.roles
  );

  const enableAudienceSummary = useSelector(
    state => state.account.accountOverviewData.client && state.account.accountOverviewData.client.props.enableAudienceSummary
  );

  useEffect(() => {
    dispatch(fetchAccountOverview());
  }, []);



  useEffect(() => {
    preWorkCampaignsState(props.campaigns.map(item=>{

      if(item.accountManager.firstName && item.accountManager.lastName){
          item.accountManager = `${item.accountManager.firstName} ${item.accountManager.lastName}`;
      }
      item.startDate = moment(item.start).format('DD MMM YYYY');
      return item
    }));
  },[props.campaigns]);


  const showActionButtonsLogic = (createdById, campaignId) =>{

    if(accountRoles && enableAudienceSummary === true){

    let shareResult = {
      IconColor: '#4651B5',
      enable: true,
    };
    let viewResult = {
      IconColor: '#4651B5',
      enable: true,
    };
    let deleteResult = {
      IconColor: '#EF4444',
      enable: true,
    };

    if(accountRoles.includes("Viewer")){
      deleteResult.enable = false;
    }else if(accountRoles.includes("User")){
      if(createdById !== currenAccountId){
        deleteResult.enable = false;
      }
    }



    return (
      <div style={{display:'flex' }}>
        { shareResult.enable === true && (
           <div
           style={CampaignDashboardTableStyle.actions}
           onClick={() => {
             handleRedirect('/share-campaign');
             dispatch(fetchShareList(campaignId));
             dispatch(setCurrentSharingCampaignId(campaignId));
          }}
           >
            <ShortcutIcon style={{fill: shareResult.IconColor}}/>
            Share
          </div>
        )}

        { viewResult.enable === true && (
          <div
          style={CampaignDashboardTableStyle.actions}
          onClick={() => {
            handleRedirect('/campaign-report');
         }}
          ><RemoveRedEyeIcon style={{fill: viewResult.IconColor}}/> View</div>
        )}

        { deleteResult.enable === true && (
          <div style={CampaignDashboardTableStyle.actionDelete}><CancelIcon style={{fill: deleteResult.IconColor}}/> Delete</div>
        )}

    </div>
    )
    }else{
      return(
        <div></div>
      )
    }
  }

  const handleRedirect = (url) => {
    history.push(url);
  };

  const columns = [
    {
      name: "name",
      label: 'CAMPAIGN',
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "advertiserName",
      label: 'ADVERTISER',
      options: {
        filter: false,
        sort: false
      }
    },
    {
      name: "agentName",
      label: 'AGENCY',
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: "agentName",
      label: 'MEDIA OWNER',
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: "accountManager",
      label: 'ACCOUNT MANAGER',
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: "startDate",
      label: 'CAMPAIGN START DATE',
      options: {
        filter: true,
        sort: false
      }
    },
    {
      name: "actions",
      label: 'ACTIONS',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return showActionButtonsLogic(props.campaigns[tableMeta.rowIndex].createdBy,props.campaigns[tableMeta.rowIndex].id );
        }
      }
    },
  ];

   // Table Options
   const options = {
    filterType: "dropdown",
    download: false,
    print: false,
    viewColumns: false,
    selectableRowsHeader	: false,
    selectableRows: "none",
    searchOpen: true,
    filter: false,
    searchAlwaysOpen: true,
    searchPlaceholder: 'Search Campaigns',
    responsive: "scrollFullHeight",
    rowsPerPageOptions:[],
    onChangePage: (currentPage) =>{

    },
  };


  // Table Custom theme
  const getMuiTheme = () =>
    createMuiTheme({
      shadows: ["none"],
      overrides: {
        MuiTableCell: {
          head: {
            fontWeight: 500,
            fontSize: '14px',
            color: '#6B7280'
          }
      }
    }
    });

  return (
    <div>
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title="Digital Organizations"
          data={campaignsState}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    </div>
  );
};

export default CampaignDashboardTable;
